// extracted by mini-css-extract-plugin
module.exports = {"card":"post-card_card__EIsX6","desc":"post-card_desc__ZopXb","image":"post-card_image__UcGZs"};